import {styled} from '@mui/material'
import {Box} from '@mui/system'
import {tabs} from 'constants/tabs'
import {useI18n} from 'store/Store'
import {StyledTab, StyledTabs} from './styles'
import TabPanel from './TabPanel'

const tabProps = (index) => {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    }
}

const Tabs = ({
    itemName,
    wrapperStyles,
    contentProps,
    data,
    errorMessage,
    tab,
    setTab,
}) => {
    const {i18n} = useI18n()
    // const [value, setValue] = useState(0)
    const {keys, content} = tabs[itemName]
    const handleChange = (event, newValue) => {
        setTab(newValue)
    }

    return (
        <Container style={wrapperStyles}>
            <StyledTabs value={tab} onChange={handleChange} aria-label="tabs">
                {keys.map((key, index) => (
                    <StyledTab
                        key={key}
                        label={i18n.t(`${itemName}s.${key}`)}
                        {...tabProps(index)}
                    />
                ))}
            </StyledTabs>
            {keys.map((key, index) => {
                const TabContent = content[key]
                return (
                    <StyledTabPanel key={key} value={tab} index={index}>
                        <TabContent
                            data={data}
                            errorMessage={errorMessage}
                            {...contentProps}
                        />
                    </StyledTabPanel>
                )
            })}
        </Container>
    )
}

export default Tabs

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const StyledTabPanel = styled(TabPanel)`
    height: 100%;
`
